<script setup lang="ts">
import type { ImagePlaceholderVariant } from "../utils/imagePlaceholder";

const props = withDefaults(defineProps<{ variant?: ImagePlaceholderVariant }>(), { variant: "generic" });

const iconName = computed(() => imagePlaceholderIcon[props.variant]);
</script>

<template>
  <div class="relative flex items-center justify-center overflow-hidden bg-linear-to-b from-lagoon-300 to-blue-700" aria-hidden="true">
    <div class="flex aspect-square w-2/5 max-w-24 items-center justify-center">
      <UIcon :name="iconName" class="size-full text-blue-800" />
    </div>
  </div>
</template>
